import React from 'react';

import Layout from '../components/Layout';

class KeysDestroyed extends React.Component {

    render(){
        return(
            <Layout>
                <h1>Report Keys Destroyed</h1>
            </Layout>
        );
    }
}

export default KeysDestroyed;